var $21e1d1ca29e01129$exports = {};
$21e1d1ca29e01129$exports = {
    "colorSwatchPicker": `V\xe4rvin\xe4idised`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`
};


export {$21e1d1ca29e01129$exports as default};
//# sourceMappingURL=et-EE.mjs.map
